import { baseFCMNotification } from "../../api/base/baseUrl";

export const bookingEnterpriseRepository = {
  async publish({ uuid, originLat, originLng }) {
    try {
      const response = await baseFCMNotification.post(
        "/api/v1/booking/enterprise/publish",
        { uuid, originLat, originLng },
        { headers: { "Content-Type": "application/json" } },
      );

      return { success: true, data: response.data.data, error: null };
    } catch (error) {
      const published =
        error.response?.data?.error?.code ===
        "BOOKING_PUBLISHED_NOTIFICATION_FAILED";

      return {
        success: false,
        data: null,
        error: published
          ? "LA RESERVA QUEDÓ PUBLICADA, PERO FALLÓ EL ENVÍO DE NOTIFICACIONES"
          : "ERROR: NO SE PUEDE PUBLICAR ESTE PEDIDO",
      };
    }
  },
};
